module.exports = __webpack_public_path__ + "media/styles/images/png/arrow-up-white-b61e509f6e103e0a1d8d0c072e58c7d9.png";